<script lang="ts" setup>
	import type { IconLibProps } from '../tools/icon.vue'

	export type uiTagConfig = {
		default: string
		base: string
		padding: string
		position: string
		zIndex: string
		rounded: string
		display: string
		font: string
		gap: string
		size: string
		icon: {
			display: string
		}
	}
	defineProps<{
		label?: string
		iconProp?: IconLibProps
		ui?: Partial<uiTagConfig>
	}>()
	const defaultCls: uiTagConfig = {
		default: '',
		base: 'tracking-wider',
		padding: 'p-[4px_12px]',
		position: 'relative',
		zIndex: 'z-10',
		rounded: 'rounded-[20px]',
		display: 'inline-flex items-center',
		font: 'font-medium',
		gap: 'gap-x-1',
		size: 'text-xs leading-[16px] ',
		icon: {
			display: 'inline'
		}
	}
</script>

<template>
	<span
		:class="[
			ui?.base ?? defaultCls.base,
			ui?.default ?? defaultCls.default,
			ui?.display ?? defaultCls.display,
			ui?.font ?? defaultCls.display,
			ui?.gap ?? defaultCls.gap,
			ui?.padding ?? defaultCls.padding,
			ui?.position ?? defaultCls.position,
			ui?.rounded ?? defaultCls.rounded,
			ui?.size ?? defaultCls.size,
			ui?.zIndex ?? defaultCls.zIndex
		]"
	>
		<tools-icon v-if="iconProp" v-bind="iconProp" :svg-class="ui?.icon?.display ?? defaultCls.icon.display" />
		<slot>{{ label }}</slot>
	</span>
</template>
